import { IS_DEV_MODE } from "@be-miniapp/app-configs"

export function TailwindIndicator() {
  if (import.meta.env.PROD) return null
  if (!IS_DEV_MODE) return null
  return (
    <div className="fixed bottom-1 left-1 z-[10000] flex size-6 items-center justify-center rounded-full bg-gray-800 p-3 font-mono text-white text-xs">
      <div className="block sm:hidden">xs</div>
      <div className="hidden sm:block md:hidden lg:hidden xl:hidden 2xl:hidden">
        sm
      </div>
      <div className="hidden md:block lg:hidden xl:hidden 2xl:hidden">md</div>
      <div className="hidden lg:block xl:hidden 2xl:hidden">lg</div>
      <div className="hidden xl:block 2xl:hidden">xl</div>
      <div className="hidden 2xl:block">2xl</div>
    </div>
  )
}
